import React, { ReactNode, useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { BreadcrumbsStore } from 'stores/breadcrumbsStore';

export interface BreadcrumbData {
  title: string;
  pathname?: string;
  search?: string;
  renamed?: boolean;
}

interface P {
  data: BreadcrumbData[];
  fullPath: string;
  children: ReactNode;
  breadcrumbsStore?: BreadcrumbsStore;
  home?: string;
}

const makePath = (fullPath: string, key: number): string =>
  fullPath
    .split('/')
    .slice(0, key + 2)
    .reduce((previous, current) => `${previous}/${current}`);

const Breadcrumbs: React.FC<P> = (props) => {
  const { data, fullPath, breadcrumbsStore, home } = props;

  useEffect(() => {
    const { addBreadcrumb, removeBreadcrumbs, setHome } = breadcrumbsStore!;
    removeBreadcrumbs();
    setHome(home);

    data.forEach((single: BreadcrumbData, key: number): void => {
      if (!single.title) return;
      addBreadcrumb({
        ...single,
        pathname: makePath(fullPath, key),
      });
    });

    return () => {
      removeBreadcrumbs();
    };
  }, [data, fullPath, breadcrumbsStore, home]);

  return <>{props.children}</>;
};

export default inject('breadcrumbsStore')(observer(Breadcrumbs));
